'use client';
import React, { useState } from 'react';
import TopBar from '@/components/plc/TopBar';
import Header from '@/components/plc/Header';
import Hero from '@/components/plc/Hero';
import TrustBar from '@/components/plc/TrustBar';
import Categories from '@/components/plc/Categories';
import FeaturedProducts from '@/components/plc/FeaturedProducts';
import Services from '@/components/plc/Services';
import SocialProof from '@/components/plc/SocialProof';
import Footer from '@/components/plc/Footer';
// import QuoteModal from '@/components/plc/QuoteModal'
; // Kept for potential future re-implementation
import QRLightbox from '@/components/plc/QRLightbox';
import WhatsAppFAB from '@/components/plc/WhatsAppFAB';

export default function PLCIraqPage() {
  const [language, setLanguage] = useState<'en' | 'ar'>('en');
  const [currency, setCurrency] = useState<'USD' | 'IQD'>('USD');
  // Quote modal state kept for potential future re-implementation
  // const [quoteModalOpen, setQuoteModalOpen] = useState(false);
  // const [prefillPartNumber, setPrefillPartNumber] = useState<string | undefined>(undefined);
  const [qrLightboxOpen, setQRLightboxOpen] = useState(false);
  const [qrType, setQRType] = useState<'whatsapp' | 'facebook' | null>(null);
  const [cartCount] = useState(0);

  const handleLanguageToggle = () => {
    setLanguage((prev) => (prev === 'en' ? 'ar' : 'en'));
  };

  const handleCurrencyToggle = () => {
    setCurrency((prev) => (prev === 'USD' ? 'IQD' : 'USD'));
  };

  // Kept for potential future re-implementation
  // const handleQuoteOpen = (partNumber?: string) => {
  //   setPrefillPartNumber(partNumber);
  //   setQuoteModalOpen(true);
  // };
  // const handleQuoteClose = () => {
  //   setQuoteModalOpen(false);
  //   setPrefillPartNumber(undefined);
  // };

  const handleQROpen = (type: 'whatsapp' | 'facebook') => {
    setQRType(type);
    setQRLightboxOpen(true);
  };

  const handleQRClose = () => {
    setQRLightboxOpen(false);
    setQRType(null);
  };

  // Stub for components that still accept onQuoteOpen prop (no-op since buttons now use WhatsApp links)
  const noopQuoteOpen = (_partNumber?: string) => {};

  return (
    <div
      className={`min-h-screen bg-white font-roboto ${
        language === 'ar' ? 'font-cairo' : 'font-roboto'
      }`}
      dir={language === 'ar' ? 'rtl' : 'ltr'}
    >
      {/* Top Utility Bar */}
      <TopBar
        language={language}
        currency={currency}
        onLanguageToggle={handleLanguageToggle}
        onCurrencyToggle={handleCurrencyToggle}
      />

      {/* Sticky Header */}
      <Header
        language={language}
        onQuoteOpen={noopQuoteOpen}
        cartCount={cartCount}
      />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <Hero language={language} onQuoteOpen={noopQuoteOpen} />

        {/* Trust Bar */}
        <TrustBar language={language} />

        {/* Categories Grid */}
        <Categories language={language} onQuoteOpen={noopQuoteOpen} />

        {/* Featured Products */}
        <FeaturedProducts language={language} onQuoteOpen={noopQuoteOpen} />

        {/* Technical Services */}
        <Services language={language} onQuoteOpen={noopQuoteOpen} />

        {/* Social Proof */}
        <SocialProof language={language} />
      </main>

      {/* Footer */}
      <Footer language={language} onQROpen={handleQROpen} />

      {/* Quote Modal - commented out, replaced by WhatsApp direct links */}
      {/* <QuoteModal
        isOpen={quoteModalOpen}
        onClose={handleQuoteClose}
        language={language}
        prefillPartNumber={prefillPartNumber}
      /> */}

      <QRLightbox
        isOpen={qrLightboxOpen}
        type={qrType}
        onClose={handleQRClose}
        language={language}
      />

      {/* Floating WhatsApp FAB */}
      <WhatsAppFAB />
    </div>
  );
}
